import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Modal, Row } from "antd";
import { setModalActiveDetalle } from "../../../../redux/aspirante/expDigitalDucks";


export const ModalDetalle = () => {
  const dispatch = useDispatch();
  const { visible, documento } = useSelector(
    (state) => state.expDigital.modalDetalle
  );

  const cancelModal = () => {
    dispatch(setModalActiveDetalle(false, null));
  };

  return (
    <Modal
      title="Detalles"
      visible={visible}
      onCancel={() => {
        cancelModal();
      }}
      keyboard={false}
      maskClosable={false}
      width={400}
      footer={[
        <center>
          <Button
            type="primary"
            onClick={() => {
              cancelModal();
            }}
          >
            Aceptar
          </Button>
        </center>,
      ]}
    >
      <Row>
        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={24}>
          <b>Usuario:</b>
        </Col>
        <Col xxl={19} xl={19} lg={19} md={19} sm={19} xs={24}>
          {documento?.usuario}
        </Col>
      </Row>
      <Card style={{ marginTop: 10 }}>
        <b>Justificación:</b>
        <div className="justificacion">{documento?.justificacion}</div>
      </Card>
    </Modal>
  );
};
